import {mapValues, difference, keys, keyBy, omit, config, createReducer} from 'helpers';

export const questions = createReducer({}, {

  QUESTIONS_UPDATE: (state, { key, questionType, timestamp_ms, id = timestamp_ms*1000000 }) => {
    if (key.trim()) {
      return {
        ...state,
        [id]: {
          ...state[id],
          app: config.app,
          id,
          serverId: id,
          key,
          type: questionType || state[id].type,
        }
      }
    }
    return state;
  },

  DIARY_CHECK_IN: (state, { answers, date }) => ({
    ...state,
    ...mapValues(answers, (value, id) => ({
      ...state[id],
      date: date.format('MM/DD/YYYY'),
      value,
    }))
  }),

  QUESTIONS_DELETE: (state, { id }) => {
    return omit(state, id);
  },

  QUESTION_VALUE_UPDATE: (state, { id, value, date }) => {
    if (id.trim()) {
      return {
        ...state,
        [id]: {
          ...state[id],
          id,
          serverId: id,
          value: value,
          date: date,
        }
      }
    }
    return state;
  },

  SERVER_DATA_RECEIVED: (state, action) => {
    const removed = difference(keys(state), action.existingElementIds.questions);
    if (action.questions.length || removed.length) {
      return omit({
        ...state,
        ...keyBy(action.questions, 'id'),
      }, removed);
    }
    return state;
  },

  TESTING_DELETE_ALL: () => ({})

});
